import React, { useEffect } from 'react';
import './ContactForm.scss';
import PhoneInputMask from './phoneInput/PhoneInputMask';
import { useState } from 'react';
import axios from "axios";
import PhoneInput from 'react-phone-number-input';

function ContactForm({ t, onFormSuccessSubmit, onFormFailSubmit }) {

    const [formValid, setFormvalid] = useState(false);
    const [phoneValueError, setPhoneValueError] = useState('');
    const [nameError, setNameError] = useState('');
    const [mailError, setMailError] = useState('');
    const [messageError, setMessageError] = useState('');
    const [valueMask,setValueMask]= useState('');

    const [consent, setConsent] = useState(false);
    const [consentErrorState, setConsentErrorState] = useState('');
    const onToggleCheck = () => {
        setConsent(!consent);
        setConsentErrorState('');
    }
    const onChangeValue = (e) => {
        setValueMask(e);
        setPhoneHandler(e);

    }

    useEffect(() => {
        if (nameError == 'red' || mailError == 'red' || phoneValueError == 'red' || messageError == 'red') {
            setFormvalid(false)
        } else {
            setFormvalid(true)
        }
    }, [nameError, mailError, phoneValueError, messageError]);

    const [name, setName] = useState('');
    const setNameHandler = (event) => {
        setName((prev) => {
            prev = event.target.value;
            if ( prev.length <= 1) {
                setNameError('red')
            } else setNameError('')
            return prev;
        });
    };

    const [mail, setMail] = useState('');
    const setMailHandler = (event) => {
        setMail((prev) => {
            prev = event.target.value;
            const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
            if (!re.test(String(prev).toLocaleLowerCase())) {
                setMailError('red')
            } else setMailError('')
            return prev;
        });
    };

    const [phoneValue, setPhoneValue] = useState('');
    const setPhoneHandler = (value) => {
        setPhoneValue((prev) => {
            prev = value;
            if (prev <= 1000000000) {
                setPhoneValueError('red')
            } else setPhoneValueError('')
            return prev;
        });
    };
    

    const [message, setMessage] = useState('');
    const setMessageHandler = (event) => {
        setMessage((prev) => {
            prev = event.target.value;
            if (prev.length <= 1) {
                setMessageError('red')
            } else setMessageError('')
            return prev;
        });
    };
    
    const cleanValues = (name,mail,message) => {
        name('');
        mail('');
        message('');
        setMessage('');
        setValueMask('');
    }
    const onClickSendButtonHandler = () => {
        if(!consent) {
            setConsentErrorState('red');
        }
        if (formValid && consent) {
            try {
                axios.post("https://biznesexpert.bitrix24.pl/rest/2237/42fvgh7bx2gve8rc/crm.lead.add.json", {
                    fields: {
                        "TITLE": "weExpert | Contact Form",
                        "ASSIGNED_BY_ID": 11,
                        "SOURCE_ID":"UC_VVDXZR",
                        "NAME": name,
                        "COMMENTS":message,
                        "PHONE": [{ "VALUE": phoneValue, "VALUE_TYPE": "WORK" }],
                        'EMAIL': [{ "VALUE": mail , 'VALUE_TYPE':'WORK'}],
                    }
                }).then((response) => {
                    cleanValues(setName,setMail,setMessage);
                    onFormSuccessSubmit();
                }
                );
            } catch (e) {
                onFormFailSubmit();
            }
        } else console.log("????")
    }
    return (
        <div className="form-wrapper">
            <form className='contact-form' method="post" onSubmit={(e) => e.preventDefault()}>

                <div id="form-inner">
                    <div className="form-input">
                        <input type="text" className={`${'input'} ${nameError}`}
                            onChange={setNameHandler}
                            id="name"
                            value={name}
                            placeholder={t("form_name_placeholder")} />
                    </div>
                    <div className="form-input">
                        <input type="email" className={`${'input'} ${mailError}`}
                            onChange={setMailHandler}
                            id="email" value={mail}
                            placeholder="Email" />
                    </div>
                    <div className="form-input">
                        <div className="tel-wrapper">
                            <div className={`${"phone-wrapper"} ${phoneValueError}`}>
                            <PhoneInput  className='input-mask'
                                international
                                countryCallingCodeEditable={false}
                                defaultCountry="PL"
                                value={valueMask}
                                onChange={onChangeValue}
                            />
                            </div>
                        </div>
                    </div>
                    <div className="form-input">
                        <textarea className={`${"input textarea"} ${messageError}`}
                            onChange={setMessageHandler}
                            id="message" value={message}
                            placeholder={t("form_message_placeholder")}></textarea>
                    </div>
                </div>
                <div className="form-bottom">
                    <div><input className='checkbox' checked={consent} onChange={onToggleCheck} type="checkbox"  id='check'/></div>
                    <div className={`form-description ${consentErrorState}`}>
                        {t("contact_form_accept")}
                    </div>
                </div>
                <div className="contact-button">
                    <button disabled={!formValid && !consent} type="submit" className="button" onClick={()=> {onClickSendButtonHandler(); }} >{t("send")} {consent}</button>
                </div>
            </form>
        </div>
    );

}
export default ContactForm;

